import { render, staticRenderFns } from "./ViewPatient.vue?vue&type=template&id=4d69f398&"
import script from "./ViewPatient.vue?vue&type=script&lang=js&"
export * from "./ViewPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports